import Vue from 'vue';
import Router from 'vue-router';
import Signup from '@/views/Signup';
import Analyze from '@/views/Analyze';
import Home from '@/views/Home';
import DataPage from '@/views/DataPage';
// import Term from '@/views/Term';
// import PrivacyPolicy from '@/views/PrivacyPolicy';
import Share from '@/views/Share';
import User from '@/views/User';
import ForgetPassword from '@/views/ForgetPassword';
import Question from '@/views/Question';
import PublicData from '@/views/publicData';
import DetailData from '@/views/DetailData';
import Pattern from '@/views/Pattern';
import VueAnalytics from 'vue-analytics';

Vue.use(Router);

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
    },
    {
      path: '/analyze',
      name: 'analyze',
      component: Analyze,
    },
    {
      path: '/signup',
      name: 'signup',
      component: Signup,
    },
    {
      path: '/data_page',
      name: 'data-page',
      component: DataPage,
    },
    // {
    //   path: '/term',
    //   name: 'term',
    //   component: Term,
    // },
    // {
    //   path: '/privacy_policy',
    //   name: 'privacy-policy',
    //   component: PrivacyPolicy,
    // },
    {
      path: '/share/:id',
      name: 'share',
      component: Share,
    },
    {
      path: '/user',
      name: 'user',
      component: User,
    },
    {
      path: '/forget_password',
      name: 'forget-password',
      component: ForgetPassword,
    },
    {
      path: '/question',
      name: 'question',
      component: Question,
    },
    {
      path: '/public_data',
      name: 'public-data',
      component: PublicData,
    },
    {
      path: '/detail_data',
      name: 'detail_data',
      component: DetailData,
    },
    {
      path: '/pattern',
      name: 'pattern',
      component: Pattern,
    },
  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    return { x: 0, y: 0 };
  },
});

Vue.use(VueAnalytics, {
  id: 'UA-142998850-1',
  router,
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js